const user = {
  login: {
    type: 'post',
    url: 'qu-platform-auth-api/auth/token'
  },
  loginAD: {
    type: 'post',
    url: 'qu-platform-auth-api/auth/tokenWithAD'
  },
  getUserInfo: {
    type: 'post',
    url: 'qu-live-manage/common/user/getUser'
  },
  getMenus: {
    type: 'post',
    url: 'qu-platform-auth-api/auth/acl/tree/user'
  },
  getUserInformation: {
    type: 'get',
    url: `qu-platform-auth-api/user/home/user/info`
  },
  //
  updatePassword: {
    type: 'post',
    url: `ec-pc-api/ds-user/updatePassword`
  },
  authListUserButton: {
    type: 'post',
    url: `qu-platform-auth-api/auth/acl/list/user/button`
  },
  // 应用列表
  myAppList: {
    type: 'get',
    url: '/qu-platform-auth-api/myApp/list'
  },
  // 角色列表
  userRoles: {
    type: 'get',
    url: '/qu-platform-auth-api/auth/user/roles'
  }
    
};

export default user;
